import OneLinkUrlGenerator from './appFlyerOneLink';

export default () => {
  const onelinkGenerator = new OneLinkUrlGenerator(
    {
      oneLinkURL: 'https://goalsetter.onelink.me/XNLm/',
      pidKeysList: ['af_pid', 'utm_source'],
      campaignKeysList: ['af_c', 'utm_campaign'],
      pidStaticValue: ['website'],
      gclIdParam: 'af_sub1',
      pidOverrideList: {
        google: 'googleadwords_int',
        bing: 'bingsearch_int',
        facebook: 'Facebook%20Ads',
      },
    },
  );

  onelinkGenerator.setCustomParameter('utm_term', 'af_keywords');
  onelinkGenerator.setCustomParameter('af_c_id', 'af_c_id');
  onelinkGenerator.setCustomParameter('af_adset_id', 'af_adset_id');

  onelinkGenerator.setAfSub1('msclkid');
  onelinkGenerator.setAd('utm_content');

  let getStartedLink = onelinkGenerator.generateUrl();

  if (!getStartedLink) {
    getStartedLink = 'https://goalsetter.onelink.me/XNLm/';
  }

  return getStartedLink;
};
